import Bowser from 'bowser';
import { img } from '../config';

const system = Bowser.parse(window.navigator.userAgent);
const browser = Bowser.getParser(window.navigator.userAgent);
let validBrowser = browser.satisfies({
  // https://lancedikson.github.io/bowser/docs/
  windows: {
    "internet explorer": ">1000",
    "Microsoft Edge": ">1000",
    edge: ">=1000",
    chrome: ">78",
    firefox: ">71",
  },
  // macos: {
  //   safari: ">=13"
  // },

  // per platform (mobile, desktop or tablet)
  mobile: {
    chrome: ">78",
    firefox: ">22",
    opera: ">=54",
    edge: ">=44",
    "Samsung Internet for Android": ">=10",
  },
  safari: '>=12',
});

let status;

switch (validBrowser) {
  case undefined:
    status = 'not tested';
    break;
  case true:
    status = 'OK';
    break;
  default:
    status = 'failed';
}

const pwa = window.matchMedia('(display-mode: standalone)').matches;

const output = {
  status,
  system,
  pwa,
  message: errorMessage(),
};

export default output;

function errorMessage() {
  if (system.platform.type === 'desktop') return desktopMessage();
  if (system.os.name === 'Android') return androidMessage();
  if (system.os.name === 'iOS') return iOSMessage();
  return generalMessage();
}

function iOSMessage() {
  return `
    <h3>Niewspierana przeglądarka</h3>
    <p>Twoja przeglądarka nie jest wsperana przez aplikację lub jest nieaktualna. Możesz kontynuować, jednak niektóre funkcje programu mogą działać nieprawidłowo.</p>
    <p>Zalecamy uruchomienie platformy na sprawdzonej przeglądarce lub aktualizację do najnowszej wersji:<p>
    <a href="https://apps.apple.com/pl/app/firefox-private-safe-browser/id989804926">
      <img src="${img('firefox-logo.png')}" alt="Firefox" />
      <span>Pobierz Firefoxa<br><small>(zalecane)</small></span>
    </a>
    <a href="https://apps.apple.com/pl/app/opera-touch-web-browser/id1411869974?l=pl">
      <img src="${img('opera-logo.png')}" alt="Opera" />
      <span>Pobierz Operę</span>
    </a>
  `
}

function androidMessage() {
  return `
    <h3>Niewspierana przeglądarka</h3>
    <p>Twoja przeglądarka nie jest wsperana przez aplikację lub jest nieaktualna. Możesz kontynuować, jednak niektóre funkcje programu mogą działać nieprawidłowo.</p>
    <p>Zalecamy uruchomienie platformy na sprawdzonej przeglądarce lub aktualizację do najnowszej wersji:<p>
    <a href="https://play.google.com/store/apps/details?id=org.mozilla.firefox&hl=pl">
      <img src="${img('firefox-logo.png')}" alt="Firefox" />
      <span>Pobierz Firefoxa<br><small>(zalecane)</small></span>
    </a>
    <a href="https://play.google.com/store/apps/details?id=com.opera.browser&hl=pl">
      <img src="${img('opera-logo.png')}" alt="Opera" />
      <span>Pobierz Operę</span>
    </a>
  `
}

function desktopMessage() {
  return `
    <h3>Niewspierana przeglądarka</h3>
    <p>Twoja przeglądarka nie jest wsperana przez aplikację lub jest nieaktualna. Możesz kontynuować, jednak niektóre funkcje programu mogą działać nieprawidłowo.</p>
    <p>Zalecamy uruchomienie platformy na sprawdzonej przeglądarce lub aktualizację do najnowszej wersji:<p>
    <a href="https://www.google.com/intl/pl_pl/chrome/">
      <img src="${img('chrome-logo.png')}" alt="Chrome" />
      <span>Pobierz Chrome<br><small>(zalecane)</small></span>
    </a>
    <a href="https://www.mozilla.org/pl/firefox/">
      <img src="${img('firefox-logo.png')}" alt="Firefox" />
      <span>Pobierz Firefoxa</span>
    </a>
    <a href="https://www.opera.com/pl">
      <img src="${img('opera-logo.png')}" alt="Opera" />
      <span>Pobierz Operę</span>
    </a>
  `
}

function generalMessage() {
  return `
  <h3>Niewspierana przeglądarka</h3>
  <p>Twoja przeglądarka nie jest wsperana przez aplikację lub jest nieaktualna. Możesz kontynuować, jednak niektóre funkcje programu mogą działać nieprawidłowo.</p>
  <p>Zalecamy uruchomienie platformy na sprawdzonej przeglądarce lub aktualizację do najnowszej wersji:<p>
  <a href="https://www.mozilla.org/pl/firefox/">
    <img src="${img('firefox-logo.png')}" alt="Firefox" />
    <span>Firefox</span>
  </a>
  <a href="https://www.opera.com/pl">
    <img src="${img('opera-logo.png')}" alt="Opera" />
    <span>Opera</span>
  </a>
`
}